import { useEffect } from 'react';
import { IJobData } from '@domain/constant/v1/jobType';
import classnames from 'classnames/bind';
import styles from './dotChartInfoTab.module.scss';

const cx = classnames.bind(styles);

interface Props {
  listData: IJobData[];
  itemsEls: HTMLLIElement[];
  currentItemIndex: number;
  scrollOffset: number;
  clearTab: () => void;
  updateCurrentItemIndex: (value: number) => void;
}

const List = ({ listData, clearTab, currentItemIndex, itemsEls, scrollOffset, updateCurrentItemIndex }: Props) => {
  useEffect(() => {
    clearTab();
  }, [listData]);

  const list = listData?.map((item, index) => {
    return (
      <li
        key={index}
        ref={(itemEl) => {
          itemsEls && itemEl && (itemsEls[index] = itemEl);
        }}
        className={cx('item', { selected: currentItemIndex === index })}
      >
        <a className={cx('btnTab')} role="button" onClick={() => updateCurrentItemIndex(index)}>
          {item.job}
        </a>
      </li>
    );
  });

  return (
    <ul className={cx('list')} style={{ transform: `translate3d(${scrollOffset}px, 0px, 0px)` }}>
      {list}
    </ul>
  );
};

const DotChartInfoTab = ({ currentItemIndex, updateCurrentItemIndex, ...rest }: Props) => {
  return (
    <div className={cx('wrap')}>
      <div className={cx('tab')}>
        <div className={cx('sliderArea')}>
          <div className={cx('slider')}>
            <List currentItemIndex={currentItemIndex} updateCurrentItemIndex={updateCurrentItemIndex} {...rest} />
          </div>
        </div>
        <div className={cx('btnWrap')}>
          <a className={cx('btn', 'prev')} onClick={() => updateCurrentItemIndex(currentItemIndex - 1)} role="button" />
          <a className={cx('btn', 'next')} onClick={() => updateCurrentItemIndex(currentItemIndex + 1)} role="button" />
        </div>
      </div>
    </div>
  );
};

export default DotChartInfoTab;
